import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'
import { ITrack } from '../../../../Interface/track'
import { SsrService } from '../../../../services/ssr.service'
import { TracksService } from '../../../../services/tracks.service'

@Component({
  selector: 'bmcore-chart-toppers',
  templateUrl: './bmcore-chart-toppers.component.html',
  styleUrls: ['./bmcore-chart-toppers.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreChartToppersComponent implements OnInit {
  pageSize = 10
  tracks: ITrack[] = []

  constructor(
    private tracksService: TracksService,
    private ssrService: SsrService
  ) {}

  ngOnInit(): void {
    this.ssrService.wait('bmcore-chart-toppers: tracksService.getChartToppersBeats')
    this.tracksService.getChartToppersBeats(this.pageSize).subscribe(res => {
      this.ssrService.ready('bmcore-chart-toppers: tracksService.getChartToppersBeats')
      this.tracks = res.items
    })
  }
}
